import {Component, OnInit} from '@angular/core';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {arrayToStr, strToArray} from './Util';
import {BusinessFieldRef} from '../model/BusinessFieldRef';
import {BoInstanceSelectorRecord} from '../model/BoInstanceSelectorRecord';
import {BusinessFieldInstance} from '../model/BusinessFieldInstance';
import {BoInstanceSelectorConfig} from './bo-instance-selector/BoInstanceSelectorConfig';
import {BoInstanceAmountToSave} from '../model/BoInstanceAmountToSave';
import {BoInstanceToSave} from '../model/BoInstanceToSave';
import {BoiDialogData} from '../model/BoiDialogData';

@Component({
  selector: 'app-dff-business-object',
  templateUrl: './dff-business-object.component.html',
  styleUrls: ['./dff-business-object.component.scss']
})
export class DffBusinessObjectComponent extends AbstractDynamicFormFieldDirective implements OnInit {
  ids: string[];
  fields: BusinessFieldRef[];
  selectorConfig: BoInstanceSelectorConfig;

  ngOnInit() {
    this.fields = this.field.objectFields.map(this.toBusinessFieldRef);
    this.selectorConfig = this.createSelectorConfig();
  }

  validate(value: string): string[] {
    if (this.field.isRequired) {

      if (!this.ids || this.ids.length === 0) {
        return ['validate_required'];
      }

    }

    return [];
  }

  createSelectorConfig(): BoInstanceSelectorConfig {
    return {
      canChangeSettings: false,
      isEditable: !this.field.isReadonly,
      type: this.field.viewType,
      ownerBoId: this.innerService.ownerData.ownerBoId,
      ownerBoInstanceId: this.innerService.ownerData.ownerBoInstanceId,
      ownerFieldId: this.field.fieldId,
      costCalcEnabled: this.field.costCalcEnabled,
      costCalcPriceLabel: this.field.costCalcPriceLabel,
      costCalcFieldId: this.field.costCalcFieldId,
      boiDraftId: this.innerService.boiDraftId
    };
  }

  writeValue(value: string) {
    this.ids = strToArray<string>(value);
  }

  addBoInstance(record: BoInstanceSelectorRecord) {
    this.ids.push(record.boInstanceId);
    this.changeValue(arrayToStr(this.ids));
  }

  deleteBoInstance(record: BoInstanceSelectorRecord) {
    this.ids = this.ids.filter(x => x !== record.boInstanceId);
    this.changeValue(arrayToStr(this.ids));
  }

  clearIds() {
    this.ids = [];
    this.changeValue(arrayToStr(this.ids));
  }

  toBusinessFieldRef(x: BusinessFieldInstance): BusinessFieldRef {
    return {
      fieldId: x.fieldId,
      toShow: true,
      orderIndex: x.orderIndex,
      label: x.label,
      checked: undefined,
      type: x.type
    };
  }

  saveBoiAmount(amountToSave: BoInstanceAmountToSave) {
    this.innerService.saveBoiAmount(amountToSave);
  }

  saveBoToSave(toSave: BoInstanceToSave) {
    this.innerService.saveBoInstance(toSave);
  }

  openBoiDialog(data: BoiDialogData) {
    this.innerService.openBioDialog(data);
  }
}
